import { render, staticRenderFns } from "./DetalheMapa.vue?vue&type=template&id=b3aecfae"
import script from "./DetalheMapa.vue?vue&type=script&lang=js"
export * from "./DetalheMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports